import { useUserContext } from '../context';
import { EnterpriseType, UserType } from '../types';

export const useUserType = () => {
    const { userType, enterpriseType } = useUserContext();

    return {
        isPortfolioPropertyUser: userType === UserType.Properties && enterpriseType === EnterpriseType.Portfolio,
        isPortfolioCentralUser: userType === UserType.Portfolio && enterpriseType === EnterpriseType.Portfolio,
        isPropertyUser: userType === UserType.Local && enterpriseType === EnterpriseType.Property,
        isCentralUser: userType === UserType.Portfolio && enterpriseType === EnterpriseType.Property,
    };
};
